import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { announcementService, userService, deviceService, authService } from '../../_services'
import { Row, Col, Alert, Spinner } from 'react-bootstrap'
import { useTranslation } from "react-i18next";
import moment from 'moment'
import styles from './details.module.css';

function AnnouncementDetails() {

	const [announcement, setAnnouncement] = useState(null)
	const [users, setUsers] = useState([])
	const [usersDownloaded, setUsersDownloaded] = useState(false)
	const [devices, setDevices] = useState([])
	const [devicesDownloaded, setDevicesDownloaded] = useState(false)
	const { id } = useParams()
	const { t } = useTranslation('common')

	useEffect(() => {
		announcementService.get(id).then(announcement => {
			announcement.users.sort((user1, user2) => user2.id - user1.id)
			setAnnouncement(announcement)
		})
		announcementService.getUsers().then(users => {
			setUsers(users)
			setUsersDownloaded(true)
		})
		announcementService.getDevices().then(devices => {
			setDevices(devices)
			setDevicesDownloaded(true)
		})
	}, [])

	const formatDate = date => {
		if (date) {
			return moment(date).format('YYYY-MM-DD HH:mm')
		}
		return '-'
	}

	const formatUser = userId => {
		var user = users.find(user => user.id == userId)
		if (user) {
			return user.username
		}
		return userId
	}

	const formatDevice = deviceId => {
		var device = devices.find(device => device.id == deviceId)
		if (device) {
			return device.username
		}
		return deviceId
	}

	const formatOsVersion = deviceId => {
		var device = devices.find(device => device.id == deviceId)
		if (device) {
			if (device.osVersion.includes('Android')) {
				return 'Android'
			} else if (device.osVersion.includes('iOS')) {
				return 'iOS'
			}
		}
		return '-'
	}

    return (
		<div>
			{ announcement &&
				<>
					<h2>
		                {t('announcement.details')}
		            </h2>
		            <Row className={styles.announcementDetails}>
		                <Col xl="2">
		                    { authService.hasRoles(['ROLE_SUPER_ADMIN']) &&
		                        <div>
				                    <label>
				                        {t('announcement.columns.customer')}
				                    </label>
				                    { announcement.customerName || '-' }
			                    </div>
		                    }
		                    <div>
			                    <label>
			                        {t('announcement.columns.type')}
			                    </label>
			                    { announcement.type || '-' }
		                    </div>
		                    <div>
			                    <label>
			                        {t('announcement.columns.platforms')}
			                    </label>
			                    { announcement.platforms.join(", ") }
		                    </div>
		                    <div>
			                    <label>
			                        {t('announcement.columns.broadcast')}
			                    </label>
			                    { announcement.broadcast ? t('crudtable.yes') : t('crudtable.no') }
		                    </div>
		                    <div>
			                    <label>
			                        {t('announcement.columns.dismissible')}
			                    </label>
			                    { announcement.dismissible ? t('crudtable.yes') : t('crudtable.no') }
		                    </div>
	                    </Col>
	                    <Col xl="2">
		                    <div>
			                    <label>
			                        {t('announcement.columns.startdate')}
			                    </label>
			                    { formatDate(announcement.startDate) }
		                    </div>
		                    <div>
			                    <label>
			                        {t('announcement.columns.enddate')}
			                    </label>
			                    { formatDate(announcement.endDate) }
		                    </div>
		                    <div>
			                    <label>
			                        {t('announcement.columns.datecreated')}
			                    </label>
			                    { formatDate(announcement.dateCreated) }
		                    </div>
		                    <div>
			                    <label>
			                        {t('announcement.columns.lastupdated')}
			                    </label>
			                    { formatDate(announcement.lastUpdated) }
		                    </div>
		                </Col>
		                <Col xl="8">
		                    <div>
			                    { Object.entries(announcement.translations).map((entry, index) => {
									return <div key={entry[0]}>
										<label>
											{ entry[0] }
										</label>
										<Alert
						                    style={{marginTop: '10px'}}
						                    variant={announcement.type.toLowerCase()}
						                    onClose={e => console.log(e)}
						                    dismissible={announcement.dismissible}
						                >
							                { entry[1] }
							            </Alert>
									</div>
								})}
				            </div>
		                </Col>
		            </Row>
		            { announcement.platforms.includes('WEB') &&
			            <Row style={{marginTop: '20px'}}>
			                <Col>
				                { usersDownloaded &&
					                <table className="table">
					                    <thead>
					                        <tr>
					                            <th>
													{t('announcementuser.columns.user')}
					                            </th>
					                            <th>
													{t('announcementuser.columns.dateread')}
					                            </th>
					                            <th>
													{t('announcementuser.columns.datedismissed')}
					                            </th>
					                            <th>
													{t('announcementuser.columns.datecreated')}
					                            </th>
					                            <th>
													{t('announcementuser.columns.lastupdated')}
					                            </th>
					                        </tr>
					                    </thead>
					                    <tbody>
					                    { announcement.users.length == 0 &&
					                        <tr>
					                            <td colSpan="5">
					                                {t('announcement.nousers')}
					                            </td>
					                        </tr>
					                    }
					                    { announcement.users.map(announcementUser => {
					                        return <tr key={announcementUser.id}>
					                            <td>
					                                { formatUser(announcementUser.user) }
					                            </td>
					                            <td>
					                                { formatDate(announcementUser.dateRead) }
					                            </td>
					                            <td>
					                                { formatDate(announcementUser.dateDismissed) }
					                            </td>
					                            <td>
					                                { formatDate(announcementUser.dateCreated) }
					                            </td>
					                            <td>
					                                { formatDate(announcementUser.lastUpdated) }
					                            </td>
					                        </tr>
					                    })}
					                    </tbody>
					                </table>
				                }
				                { !usersDownloaded &&
									<Spinner animation="border" role="status">
										<span className="sr-only">Loading...</span>
									</Spinner>
				                }
			                </Col>
			            </Row>
		            }
		            { (announcement.platforms.includes('ANDROID') || announcement.platforms.includes('IOS')) &&
		                <Row style={{marginTop: '20px'}}>
		                    <Col>
				                { devicesDownloaded &&
					                <table className="table">
					                    <thead>
					                        <tr>
					                            <th>
													{t('announcementdevice.columns.username')}
					                            </th>
					                            <th>
													{t('announcementdevice.columns.platform')}
					                            </th>
					                            <th>
													{t('announcementdevice.columns.dateread')}
					                            </th>
					                            <th>
													{t('announcementdevice.columns.datedismissed')}
					                            </th>
					                            <th>
													{t('announcementdevice.columns.datecreated')}
					                            </th>
					                            <th>
													{t('announcementdevice.columns.lastupdated')}
					                            </th>
					                        </tr>
					                    </thead>
					                    <tbody>
					                    { announcement.devices.length == 0 &&
					                        <tr>
					                            <td colSpan="5">
					                                {t('announcement.nodevices')}
					                            </td>
					                        </tr>
					                    }
					                    { announcement.devices.map(announcementDevice => {
					                        return <tr key={announcementDevice.id}>
					                            <td>
					                                { formatDevice(announcementDevice.device) }
					                            </td>
					                            <td>
					                                { formatOsVersion(announcementDevice.device) }
					                            </td>
					                            <td>
					                                { formatDate(announcementDevice.dateRead) }
					                            </td>
					                            <td>
					                                { formatDate(announcementDevice.dateDismissed) }
					                            </td>
					                            <td>
					                                { formatDate(announcementDevice.dateCreated) }
					                            </td>
					                            <td>
					                                { formatDate(announcementDevice.lastUpdated) }
					                            </td>
					                        </tr>
					                    })}
					                    </tbody>
					                </table>
				                }
				                { !devicesDownloaded &&
				                    <Spinner animation="border" role="status">
										<span className="sr-only">Loading...</span>
									</Spinner>
				                }
			                </Col>
			            </Row>
		            }
				</>
			}
        </div>
    )
}

export default AnnouncementDetails;